import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { UserState, UserStateInitial } from '../store/user-data.state';
import { UserActions } from '../store/actions';
import { AppConstants } from '../../../SGRE-shared/constants/app-constant';
import { Router } from '@angular/router';
import * as StorageActions from '../../../SGRE-shared/store/shared-store/actions/browser-storage.action';
import { User } from '../model/user-page-model';
import { selectUserData } from '../store/selector/users.selector';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  public filteredData = [];

  constructor(
    protected store: Store<UserState>,
    private router: Router
  ) { }

  loadUserData(queryText): void {
    this.store.dispatch(UserActions.loadUsersTableData(queryText));
  }

  getUserData(): Observable<UserStateInitial> {
    return this.store.select(selectUserData);
  }

  navigateUserProfile(data: string): void {
    this.store.dispatch(StorageActions.setUserProfileData({ userProfileData: User.USER }));
    this.router.navigate([AppConstants.routeUrls.userProfile], {
      queryParams: { user: data },
    });
  }

  //old code

  // getlegalentities(paramsObject) {
  //   return this.apiService.getlegalentities(paramsObject, {});
  // }

  // userssgredetails(paramsObject) {
  //   return this.apiService.userssgredetails(paramsObject, {});}
}
